var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Base',{staticClass:"mb-1"},[[_c('ListTransaction',{attrs:{"showPagination":false,"showPaginationFooter":true}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }